import React, { type FunctionComponent, useMemo } from 'react'
import { DashSwitch } from '../../legacy/dash-components/dash-switch/DashSwitch'
import { DashRedirect } from '../../legacy/dash-components/dash-redirect/DashRedirect'
import { useCoreContext } from '../../utils/core/RPPCoreContext'
import { RouteSuspense } from '../../legacy/dash-components/route-suspense/RouteSuspense'
import clientEnv from '../../utils/global/clientEnv'

export const DevPortalSectionRoutes: FunctionComponent = () => {
  const coreContext = useCoreContext()

  const devPortalRouters = useMemo(
    () => coreContext.devPortalRouters.map(el => React.cloneElement(el, { key: el.props.route })),
    [coreContext]
  )

  return (
    <RouteSuspense>
      <DashSwitch>
        {devPortalRouters}
        {clientEnv.PUBLIC_CLIENT_ENVIRONMENT == 'production' ? (
          <DashRedirect toRoute="app-dev-portal-webhook-configuration" />
        ) : (
          <DashRedirect toRoute="app-dev-portal-fulfillment-testing-center" />
        )}
      </DashSwitch>
    </RouteSuspense>
  )
}
